import {Directive, ElementRef, forwardRef, Attribute} from '@angular/core';
import {Validator, AbstractControl, NG_VALIDATORS, DefaultValueAccessor} from '@angular/forms';
import {PhonePipe} from './phone.pipe';

@Directive({
    selector: '[numonly]',
    host: {
        '(blur)': 'format()',
        '(keydown)': 'format()',
        '(focus)': 'format()',
    

    },
    providers: [
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => NumOnlyDirective), multi: true},
        DefaultValueAccessor
    ]
})
export class NumOnlyDirective implements Validator {
    public startsCount = 0;

    constructor(private element: ElementRef, @Attribute('min') public min: string,
                @Attribute('max') public max: string,
                @Attribute('maxlength') public maxlength: string,
                @Attribute('numonly') public numonly: string,private phonepipe:PhonePipe) {
        let allowed = [8, 9, 13, 33, 34, 35, 36, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123];
        let allowed1 = [8, 9, 13, 33, 34, 35, 36, 37, 38, 39, 40, 46];
        element.nativeElement.onkeydown = (event:any) => {
            let ml = (typeof maxlength != 'undefined' && maxlength != null && !isNaN(parseInt(maxlength)) ) ? parseInt(maxlength) : 100000;
            let tl = ('' + ((element.nativeElement.firstElementChild.value != null) ? element.nativeElement.firstElementChild.value : '')).length;
            if (allowed.indexOf(event.keyCode) < 0 || ( tl >= ml && allowed1.indexOf(event.keyCode) < 0 )) {
                event.preventDefault();
                event.stopPropagation();
            }

        }
    }

    format(mode:any) {
        if (this.numonly === null || this.numonly === '')
            return;
        this.startsCount = 0;
        for (let _il = 0; _il < this.numonly.length; _il++)
            this.startsCount += (this.numonly[_il] === '*') ? 1 : 0;
        let temp = this.element.nativeElement.firstElementChild.value;
        console.log(temp);
        //console.log(this.element);
        if (!mode) {
            let val = '';
            let ci = 0;
            for (let _il = 0; _il < this.numonly.length; _il++) {
                if (this.numonly[_il] != '*') {
                    val += this.numonly[_il];
                } else {
                    if (temp.length > ci) {
                        val += temp[ci];
                        ci++;
                    } else {
                        break;
                    }
                }
            }
            this.element.nativeElement.firstElementChild.value = this.phonepipe.transform(this.element.nativeElement.firstElementChild.value,[]);// val;
        } else {
            this.element.nativeElement.firstElementChild.value = this.removeNonNumbers(this.element.nativeElement.firstElementChild.value);
            this.element.nativeElement.dispatchEvent(new Event('input'));
        }
    }

    removeNonNumbers(val:any) {
        val = (val != null) ? '' + val : val;
        if (val === null || typeof val === 'undefined')
            return val;
        let res = '';
        for (let _il = 0; _il < val.length; _il++)
            res += (val.charCodeAt(_il) > 47 && val.charCodeAt(_il) < 58) ? val[_il] : '';
        return res;
    }

    validate(c: AbstractControl): {[key: string]: any} {
        // self value
        let v = c.value;
        let x = this.removeNonNumbers(v);
        if (v != x) {
            this.element.nativeElement.firstElementChild.value = x;
            this.element.nativeElement.dispatchEvent(new Event('input'));
            return c.errors;
    }
        if (this.min != null && this.min != '' && !isNaN(parseInt(this.min)) && parseInt(v) < parseInt(this.min)) {
            return {
                min: true
            }
        }
        if (this.max != null && this.max != '' && !isNaN(parseInt(this.max)) && parseInt(v) > parseInt(this.max)) {
            return {
                max: true
            }
        }
        return null;
    }


}


// WEBPACK FOOTER //
// ./src/app/shared/_pipes/number.directive.ts